module.exports = __webpack_public_path__ + "img/CanadaDay2026Flyer.e8f983d2.jpg";